import messages  from "/core/stores/alertsStore.js";

export function processAlerts(res) {
    res.then(res => {
        if (res.hasOwnProperty('messages')) {
            if (res.messages.length > 0) {
                res.messages.forEach(m => {
                    messages.add(m);
                });

            }
        }
    });
}

export function processOneAlert(alert) {
    messages.add(alert);
}

export function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}